.me-socials {
  margin-left: calc(-1 * var(--spacing-2xs));
  margin-right: calc(-1 * var(--spacing-2xs));
}

.me-socials__item {
  margin: 0 var(--spacing-2xs);
  color: inherit;
}
